export default "__VITE_ASSET__DQM4EkRT__"